import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import HomePage from './pages/HomePage';
import LobbyPage from './pages/LobbyPage';
import RoomPage from './pages/RoomPage';
import GamePage from './pages/GamePage';
import GizmosLobbyPage from './pages/GizmosLobbyPage';
import GizmosRoomPage from './pages/GizmosRoomPage';
import GizmosGamePage from './pages/GizmosGamePage';
import './App.css';

function PrivateRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
}

function App() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/home" /> : <LoginPage />} />
      <Route path="/register" element={user ? <Navigate to="/home" /> : <RegisterPage />} />

      {/* 游戏中心 */}
      <Route path="/home" element={<PrivateRoute><HomePage /></PrivateRoute>} />

      {/* Splendor */}
      <Route path="/lobby" element={<PrivateRoute><LobbyPage /></PrivateRoute>} />
      <Route path="/games/:id/room" element={<PrivateRoute><RoomPage /></PrivateRoute>} />
      <Route path="/games/:id/play" element={<PrivateRoute><GamePage /></PrivateRoute>} />

      {/* Gizmos */}
      <Route path="/gizmos/lobby" element={<PrivateRoute><GizmosLobbyPage /></PrivateRoute>} />
      <Route path="/gizmos/:id/room" element={<PrivateRoute><GizmosRoomPage /></PrivateRoute>} />
      <Route path="/gizmos/:id/play" element={<PrivateRoute><GizmosGamePage /></PrivateRoute>} />

      <Route path="*" element={<Navigate to={user ? "/home" : "/login"} replace />} />
    </Routes>
  );
}

export default App;
